// Jeden react-query klient pro celou aplikaci (289) — api.js ho po zápisu na server použije.
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      // 261: výpadek serveru už ~45 s zkoušel api.js — další 3 pokusy by jen prodloužily čekání
      retry: (count, err) => !err?.ppServerDown && count < 3,
    },
  },
});

// 289: Souhrny přes celou firmu (Přehled Ekonomiky) počítají z dokladů, plateb, pokladny,
// docházky i zakázek najednou. Po každém zápisu na server se jejich uložená čísla zahodí —
// při dalším otevření se načtou znovu (dřív ukázaly až minutu stará čísla) a otevřený
// Přehled se přepočítá hned. Na každé místo, které něco ukládá, se tak nemusí myslet zvlášť.
const AFTER_WRITE = [["eco-overview"]];
// Zápisy, které souhrny nemění: přihlášení, oznámení, kontrola duplicit při psaní.
const NO_CHANGE = ["/auth/", "/notifications", "check-duplicates"];

export function dropAfterWrite(method, url = "") {
  if (["get", "head", "options"].includes((method || "get").toLowerCase()) || NO_CHANGE.some((p) => url.includes(p))) return;
  for (const queryKey of AFTER_WRITE) {
    queryClient.removeQueries({ queryKey, type: "inactive" });
    queryClient.invalidateQueries({ queryKey, refetchType: "active" }, { cancelRefetch: false });
  }
}
